import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import {RequestServiceProvider} from "../../providers/request-service/request-service";

/**
 * Generated class for the MicrofinanceBankSelectorPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-bank-selector',
  templateUrl: 'bank-selector.html'
})
export class BankSelectorPage {

  public search: string = "";
  public banks: any[] = [];
  public loading: boolean =false;
  public nextPage: string = 'SendMoneyToAccountPage';
  public type = 'commercial';
  //public allowedCommercial: string[] = [ '044', '057'];

  constructor(public navCtrl: NavController, public navParams: NavParams, protected dataService: RequestServiceProvider) {
    this.setType(this.navParams.get('type') || 'commercial');
    this.setNextPage(this.navParams.get('next') || 'SendMoneyToAccountPage');
  }

  setNextPage(page: string){
    console.log('next page', page);
    this.nextPage = page;
  }
  setType(type: string){
    this.type = type;
    console.log('type', type);
  }

  get filteredBanks() {
    return this.banks.filter(item => {
      return item.name.match(new RegExp(this.search,'gi'));
    })/* .filter(item => {
      return this.type == 'commercial' ? this.allowedCommercial.includes(item.cbn) : true ;
    }) */
  }

  getBanks(){
    this.loading = true;
    this.fromType().subscribe( banks => {
      this.banks = banks;
      this.loading = false;
    })
  }


  fromType() {

    switch (this.type) {
      case 'mfb':
       return this.dataService.getMicrofinanceBanks();
      case 'mmo':
       return this.dataService.getMobileMoneyOperators();
      default:
       return this.dataService.getSanefBankList();
    }

  }

  next(bank){
    this.navCtrl.push(this.nextPage, {bank,type:this.type});
  }


  ionViewDidLoad() {
    this.getBanks();
  }

}



// WEBPACK FOOTER //
// ./src/pages/bank-selector/bank-selector.ts